export enum IdNumberTypes {
  ID_CARD = "IDC",
}
